export const processFormValues = (value: unknown) => {
  //TODO: Handle arrays / objects
  return value as string;
};
